'use client';

import Link from 'next/link';

import { AgahButtonLogo, LogoWhite } from '../../icons';

import { MobileNavItem, useMobileNavbar } from '../model';

export const MobileNavbar = () => {
  const { data: mobileNavLinks, theme, isActive, handleClick, showNav } = useMobileNavbar();

  if (!showNav) return null;

  return (
    <nav className='fixed bottom-0 left-0 right-0 bg-background border-t border-border shadow-md'>
      <div className='flex justify-between items-center px-4 h-[72px] relative'>
        {mobileNavLinks.map((item) => {
          const active = isActive(item.id);
          const isDark = theme.resolvedTheme === 'dark';
          const activeColor = 'text-blue-1';
          const inactiveColor = isDark ? 'text-[#F9F9FB]' : 'text-[#787B86]';

          return (
            <Link
              key={item.id}
              id={item.gtmid}
              prefetch={false}
              href={item.route}
              onClick={handleClick(item)}
              className='flex flex-col items-center text-sm min-w-[60px] gap-1'
            >
              <div
                className={`relative flex flex-col items-center z-10 ${item.id !== MobileNavItem.Home ? (active ? activeColor : inactiveColor) : ''}`}
              >
                {item.id === MobileNavItem.Home ? (
                  isDark ? (
                    <LogoWhite isActive={active} className='h-[24px] w-[24px]' />
                  ) : (
                    <AgahButtonLogo isActive={false} className='h-[24px] w-[24px]' />
                  )
                ) : (
                  item.icon(active)
                )}
              </div>
              <span
                className={`text-[12px] text-nowrap ${active ? `font-medium ${activeColor}` : `font-normal ${inactiveColor}`}`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
